import { render, staticRenderFns } from "./modePage.vue?vue&type=template&id=4cec1e2a&scoped=true"
import script from "./modePage.vue?vue&type=script&lang=js"
export * from "./modePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cec1e2a",
  null
  
)

export default component.exports